import { Injectable } from '@angular/core';
import { UserService } from '../../services/user.service';
import { routes } from '../../../app/routes.constant'
import { nodeTypes } from '../../../app/app-constant';
import { Subject } from '../../../../node_modules/rxjs';

@Injectable()
export class HeaderService {

  public txnSub = new Subject<string>();
  public holdingTxnSub = new Subject<string>();
  public dashboardTxnSub = new Subject<string>();
  public secMasterDataSub = new Subject<string>();

  constructor(private userService: UserService) { }

  refresh(routerUrl: string) {
    if(routerUrl == routes.BUY_TRANSACTIONS || routerUrl == routes.SELL_TRANSACTIONS){
      this.txnSub.next('Y');
    } else if(routerUrl == routes.HOLD_TRANSACTIONS_HOLDINGS){
      this.holdingTxnSub.next('Y');
    } else if(routerUrl == routes.SEC_MASTER){
      this.secMasterDataSub.next('Y');
    }
  }
}
